import { AlertCircle } from 'lucide-react';
import React from 'react';

/**
 * EmptyState
 * Componente para mostrar un mensaje cuando no hay contenido disponible.
 * 
 * @param {LucideIcon} icon - El icono a mostrar (default: AlertCircle).
 * @param {string} title - El título principal del estado vacío.
 * @param {string} description - Texto secundario descriptivo.
 * @param {string} className - Clases CSS adicionales para el contenedor.
 * @param {boolean} premium - Si es true, usa un estilo con diseño más suave y moderno.
 */
const EmptyState = ({ 
    icon: Icon = AlertCircle, 
    title, 
    description, 
    className = "",
    premium = false,
    action // New prop for CTA
}) => {
    if (premium) {
        return (
            <div className={`flex-1 flex flex-col items-center justify-center text-center p-16 ${className}`}>
                <div className="relative mb-10">
                    <div className="absolute inset-0 bg-primary/20 blur-[4rem] rounded-full animate-pulse" />
                    <div className="relative w-24 h-24 bg-white rounded-[2.5rem] shadow-2xl flex items-center justify-center text-primary/20 border border-gray-100 ring-4 ring-gray-50/50">
                        <Icon size={48} strokeWidth={1} />
                    </div>
                </div>
                <h3 className="text-2xl font-black text-primary tracking-tighter mb-3 italic">
                    {title}
                </h3>
                {description && (
                    <p className="text-xs text-gray-400 font-bold uppercase tracking-[0.2em] max-w-xs leading-relaxed mb-8">
                        {description}
                    </p>
                )}
                {action && <div className="mt-2 animate-in fade-in zoom-in duration-500">{action}</div>}
            </div>
        );
    }

    return (
        <div className={`flex flex-col items-center justify-center py-20 bg-gray-50/10 rounded-3xl border border-dashed border-gray-200/60 ${className}`}>
            <div className="w-20 h-20 bg-primary/5 rounded-full flex items-center justify-center mb-6 ring-8 ring-primary/[0.02]">
                <Icon className="text-primary/40" size={32} strokeWidth={1.5} />
            </div>
            <h3 className="text-xl font-black text-gray-900 mb-2 tracking-tight">{title}</h3>
            {description && (
                <p className="text-sm text-gray-400 font-medium text-center max-w-sm leading-relaxed mb-8 px-6">
                    {description}
                </p>
            )}
            {action && <div className="animate-in fade-in zoom-in duration-500">{action}</div>}
        </div>
    );
};

export default EmptyState;
